import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Tab, Grid, Table } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import { lpcoEnvs, lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn";
import {
    useForm,
    useFetch,
    useGrid,
    useResource,
    usePopup,
    useStore,
    useToast,
    useAuth,
    useModal,
    useTab,
    usePage,
} from "@/comn/hooks";
import {
    BASE,
    URLS,
    APIS,
    SF_SCHEMA_SRCH_HS_APP,
    SG_SRCH_HS_CODE_LIST,
} from "@/tz/go/egaz/osci/lpco/hscd/itm/service/OsciHscdItmService";

export const OSCI0204002Q = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0004"],
    });
    const pgeTitle = "Controlled HS Code List"; // Page Title !== 페이지 타이틀 ==!
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!
    const [hsAppList, setHsAppList] = useState(comnUtils.getGridData([]));
    /*
     * Code Resource
     * !== 사용할 Code 정의 ==!
     */
    useResource({
        defaultSchema: [
            { area: "hsCd" },
            { area: "comnCd", comnCd: "OSC0133" },
            { area: "comnCd", comnCd: "OSC0134" },
            { area: "comnCd", comnCd: "OSC0132" },
            { area: "comnCd", comnCd: "OSC0131" },
        ],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Registering HS Code Form !== HS 신청 Form==!
        srchHsAppForm: useForm({
            defaultSchema: SF_SCHEMA_SRCH_HS_APP,
            defaultValues: {
                orgCd: auth.get("orgCd"),
                orgNm: auth.get("orgNm"),
                // srchSbmtStrtDtm: comnUtils.getDate({ m: -1 }), // commented to allow user to see all applications
                // srchSbmtEndDtm: comnUtils.getDate(),
            },
        }),
    };
    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Registering HS Code List !== Item Tab HS Code 등록 ==!
        appHsCodeSrchList: useGrid({
            defaultSchema: SG_SRCH_HS_CODE_LIST,
            page: 0,
            size: 10,
        }),
    };

    const render = {
        appHsCodeSrchList: {
            cell: {
                hsAppNo: (props: any) => {
                    const { binding, rowValues, value } = props;
                    return (
                        <Layout direction="col" gap={1}>
                            <Link to={`${URLS.osci0204003s}/${rowValues.hsAppId}`}>{`${rowValues.hsAppNo}`}</Link>
                        </Layout>
                    );
                },
            },
        },
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        getHsAppList: useFetch({
            api: async (page = grid.appHsCodeSrchList.page) => {
                return APIS.getHsAppList(form.srchHsAppForm.getValues(), page, grid.appHsCodeSrchList.size);
            },
            enabled: comnUtils.isEmpty(form.srchHsAppForm.errors),
            key: [grid.appHsCodeSrchList.page, grid.appHsCodeSrchList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.srchHsAppForm.getValues(),
                    page: grid.appHsCodeSrchList.page,
                    size: grid.appHsCodeSrchList.size,
                });
            },
            onError: () => {},
            showToast: false,
        }),
        // getOrgLpcoList: useFetch({
        //     api: (data) => {
        //         return lpcoUtils.getOrgLpcoList(data);
        //     },
        //     onSuccess: (data) => {
        //         setOrgLpcoList(data || []);
        //     },
        //     onError: () => {},
        //     showToast: false,
        // }),
    };
    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        getHsAppList: () => {
            form.srchHsAppForm.handleSubmit(
                (data) => {
                    grid.appHsCodeSrchList.setPage(0);
                    fetch.getHsAppList.fetch(0);
                },
                (data) => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },
        setInit: async () => {
            // 목록 조회
            handler.getHsAppList();
        },
    };

    useEffect(() => {
        // 이전 검색 조건 세팅
        lpcoUtils.setSrchFormFromStore(form.srchHsAppForm, pgeStore);
        // 초기화
        handler.setInit();
    }, []);

    return (
        <Page>
            {/* <form> */}
            <Group>
                <Group.Body>
                    <Layout>
                        <Layout.Left>
                            <Group.Title title={t("L_APP_INFO")} titleSize={1}></Group.Title>
                        </Layout.Left>
                    </Layout>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.srchHsAppForm.schema.orgNm} />
                            <Group.Control {...form.srchHsAppForm.schema.srchOrgChpnNm} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.srchHsAppForm.schema.srchHsAppNo} />
                            <Group.Control {...form.srchHsAppForm.schema.srchPrcssStatCd} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control
                                {...form.srchHsAppForm.schema.srchSbmtDtm}
                                edit={true}
                                rangeButton={2}
                                controlSize={10}
                            />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control
                                {...form.srchHsAppForm.schema.srchAprvDtm}
                                edit={true}
                                rangeButton={2}
                                controlSize={10}
                            />
                        </Group.Row>
                    </Group.Section>

                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="reset"
                                onClick={() => {
                                    form.srchHsAppForm.reset({ ...lpcoUtils.orgInfo });
                                    handler.getHsAppList();
                                }}
                            ></Button>
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role="search"
                                onClick={() => {
                                    handler.getHsAppList();
                                }}
                            />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid
                            {...grid.appHsCodeSrchList.grid}
                            data={fetch.getHsAppList.data?.list}
                            render={render.appHsCodeSrchList}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
